import { render, staticRenderFns } from "./QuestionSearch.vue?vue&type=template&id=23ad23f0&scoped=true&"
import script from "./QuestionSearch.vue?vue&type=script&lang=js&"
export * from "./QuestionSearch.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSearch.vue?vue&type=style&index=0&id=23ad23f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad23f0",
  null
  
)

export default component.exports